import api from '@/api'
import axios from 'axios'

//获取验证码
export async function getCaptchaImage() {
  return  api.get('api/services/app/CommonLookup/GetCaptchaImage')
}

//登陆
export async function login(data) {
  return api.post('api/TokenAuth/MemberAuthenticate', data)
}

export async function sendMsg(data) {
  return api.post('api/TokenAuth/SendMsgBySupplier', data)
}

export async function updatePassword(data) {
  return api.post('api/TokenAuth/MemberUpdatePassword', data)
}

//登陆
export async function getLoginQRCode() {
  return api.get('api/TokenAuth/GetLoginQRCode')
}

//获取登录状态状态
export async function getLoginStatus(data) {
  return api.get('api/TokenAuth/getLoginStatus?guid='+ data.guid)
}

export async function bindingUser(data) {
  return api.post('api/TokenAuth/BindingUser', data)
}


// WEBPACK FOOTER //
// ./src/api/login.js